<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>
<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        vehicleStatusTypeOptions: [],
        categoryIdOptions: [],
        form: [
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          {
            label: '违章类型',
            value: 'categoryId',
            type: 'select',
            placeholder: '请选择违章类型',
            default: '-1',
          },
          {
            label: '违章时间',
            value: 'violationTime',
            type: 'date',
            placeholder: '违章时间',
            attr: {
              type: 'datetimerange',
            },
          },
          {
            label: '创建时间',
            value: 'createTime',
            type: 'date',
            placeholder: '创建时间',
            attr: {
              type: 'datetimerange',
            },
          },
          {
            label: '服务商',
            value: 'serviceProvider',
            type: 'input',
            placeholder: '请输入服务商',
          },
          {
            label: '申请单号',
            value: 'busiCode',
            type: 'input',
            placeholder: '请输入申请单号',
          },
        ],
      },
    };
  },
  methods: {
    sub (searchBoxData) {
      if (searchBoxData.violationTime && searchBoxData.violationTime.length) {
        searchBoxData.violationTimeStart = this.formatDate(searchBoxData.violationTime[0], 1);
        searchBoxData.violationTimeEnd = this.formatDate(searchBoxData.violationTime[1], 1);
      } else {
        searchBoxData.violationTimeStart = '';
        searchBoxData.violationTimeEnd = '';
      }
      if (searchBoxData.createTime && searchBoxData.createTime.length) {
        searchBoxData.createTimeStart = this.formatDate(searchBoxData.createTime[0], 1);
        searchBoxData.createTimeEnd = this.formatDate(searchBoxData.createTime[1], 1);
      } else {
        searchBoxData.createTimeStart = '';
        searchBoxData.createTimeEnd = '';
      }
      delete searchBoxData.violationTime;
      delete searchBoxData.createTime;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'VIOLATION_CATEGORY_ID',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.categoryIdOptions = [
      {
        label: '请选择',
        value: '-1',
      },
      ...safeEnum(0),
    ];
  },
};
</script>
<style lang="scss" scoped>
</style>
